var map = {
	"./creditcard/mastercard.svg": 14062,
	"./creditcard/visa.svg": 54489,
	"./dashed_border.svg": 27634,
	"./icons.svg": 77712,
	"./logo.svg": 61809,
	"./logo_icon.svg": 62645,
	"./partners/knab-logo.svg": 73002,
	"./payment_page/discount_code.svg": 71650,
	"./payment_page/testimonial_arrow.svg": 25918,
	"./payment_page/testimonial_star.svg": 35185,
	"./services/arrow.svg": 33666,
	"./services/blue-check.svg": 24466,
	"./services/green-check.svg": 96907,
	"./services/label.svg": 92499,
	"./socials/logo-whatsapp.svg": 29919,
	"./trackers/facebook-pixel.svg": 91155,
	"./trackers/google-tag-manager.svg": 69836
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37235;